import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useParams, useHistory } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import HoverButton from "../components/floatBoxStoreButton";

require("dotenv").config();

const Title = styled.section`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 20px;
  color: #fff;
`;

const Wrapper = styled.div`
  background: #0063ff;
  height: 60px;
  display: flex;
  padding-left: 15px;
  align-items: center;
`;

const ImgPrincipalDiv = styled.div`
  display: flex;
  justify-content: center;
  background-color: #000000;
  overflow: hidden;
  height: 300px;
`;

const SpotImg = styled.img`
  display: inline !important;
  margin: 0 auto !important;
  height: 100% !important;
  width: auto !important;
`;

const Corpo = styled.section`
  flex-direction: column;
  display: flex;
  justify-content: center;
  margin: 0px 15px;
  padding-top: 10px;
`;

const TextoPequeno = styled.section`
  padding-top: 5px;
  color: #858585;
  font-size: 9px;
`;

const TextoCutida = styled(TextoPequeno)`
  text-align: center;
`;

const TextoHashTag = styled(TextoPequeno)`
  font-size: 12px;
`;

const TextoUserName = styled(TextoPequeno)`
  font-weight: 600;
`;

const TituloPrincipal = styled.section`
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #000000;
`;

const TextoOnda = styled(TituloPrincipal)`
  font-weight: 400;
  padding-left: 5px;
`;

const DivTitulo = styled.div`
  display: flex;
  margin: 10px;
  justify-content: space-between;
`;

const DivTituloText = styled.div`
  display: flex;
  flex-direction: column;
`;

const DivTituloImg = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 65px;
`;
const UserImgDiv = styled.div`
  display: flex;
  place-content: center;
  overflow: hidden;
  border-radius: 50%;
  width: 33px;
  height: 33px;
  border: 1px solid #85858552;
`;

const UserImg = styled.img`
  display: inline;
  margin: 0 auto;
  height: 100%;
  width: auto;
`;

const TextoPost = styled.span`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: #000000;
`;

const TextoPostDestaque = styled(TextoPost)`
  font-weight: 600;
`;

const DadosVento = styled.div`
  display: flex;
  align-items: center;
`;

const DivDadosVento = styled.div`
  padding-top: 5px;
  width: 90vw;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const Loading = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

export default function Spotlight() {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [item, setItem] = useState(null);
  const [imgSrc, setImgSrc] = useState(null);
  let history = useHistory();
  const [imgIsOpen, setImgIsOpen] = useState(false);
  const [indexImg, setIndexImg] = useState(0);
  const [imgLojaIsOpen, setImgLojaIsOpen] = useState(true);

  const { token } = useParams();

  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/spotlights?token=${token}&limit=1`,
      {
        method: "GET",
        headers: new Headers({
          Authorization: `Bearer ${process.env.REACT_APP_AUTORIZATION}`,
        }),
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          if (!result || result.length === 0 || result.error) {
            history.push("/notfound");
          }

          setIsLoaded(true);
          setItem(result);
          document.title = "KiteRadar - Resenha";
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      );
  }, [token, history]);

  function fotoClick(index) {
    setIndexImg(index);
    !imgIsOpen && setImgIsOpen(true);
  }

  return item ? (
    <>
      <Wrapper>
        <Title>Resenha</Title>
      </Wrapper>
      {item?.map((element) => {
        return (
          <div>
            <DivTitulo>
              <DivTituloText>
                <TituloPrincipal>{element.title}</TituloPrincipal>
                <TextoPequeno>
                  {element?.beach?.name}, {element?.beach?.location?.city?.name}
                  , {element?.beach?.location?.state?.uf} <br />
                  {new Date(element?.created_at).toLocaleDateString()} as{" "}
                  {new Date(element?.created_at)
                    .toLocaleTimeString()
                    .substring(0, 5)}
                </TextoPequeno>
              </DivTituloText>
              <DivTituloImg>
                <UserImgDiv>
                  <UserImg
                    src={element?.user?.user_icon[0]?.photo.url}
                  ></UserImg>
                </UserImgDiv>
                <TextoUserName style={{ textAlign: "center" }}>
                  {element?.user.name} {element?.user?.last_name}
                </TextoUserName>
              </DivTituloImg>
            </DivTitulo>
            {/* <ImagemPrincipal src={element.spotlight_photos ? element.spotlight_photos[0].photo.url : ''}>
                    </ImagemPrincipal> */}
            {element?.spotlight_photos &&
            element.spotlight_photos.length > 0 ? (
              <>
                <Carousel
                  statusFormatter={(currentStatus, totalStatus) => (
                    <div>
                      {currentStatus} de {totalStatus}
                    </div>
                  )}
                  dynamicHeight={false}
                  swipeable={true}
                  autoPlay={false}
                  showThumbs={false}
                  onClickItem={fotoClick}
                >
                  {element.spotlight_photos.map((foto, index) => (
                    <ImgPrincipalDiv key={index}>
                      <SpotImg src={foto.photo.url} />
                    </ImgPrincipalDiv>
                  ))}
                </Carousel>
                {imgLojaIsOpen ? (
                  <HoverButton
                    _setImgLojaIsOpen={() => setImgLojaIsOpen(false)}
                    marginTop={"180px"}
                  />
                ) : null}
                {imgIsOpen && (
                  <Lightbox
                    imageLoadErrorMessage={
                      <div>Não foi possível carregar a imagem.</div>
                    }
                    mainSrc={element.spotlight_photos[indexImg].photo.url}
                    nextSrc={
                      element.spotlight_photos[
                        (indexImg + 1) % element.spotlight_photos.length
                      ].photo.url
                    }
                    prevSrc={
                      element.spotlight_photos[
                        (indexImg + element.spotlight_photos.length - 1) %
                          element.spotlight_photos.length
                      ].photo.url
                    }
                    onCloseRequest={() => setImgIsOpen(false)}
                    onMovePrevRequest={() =>
                      setIndexImg(
                        (indexImg + element.spotlight_photos.length - 1) %
                          element.spotlight_photos.length
                      )
                    }
                    onMoveNextRequest={() =>
                      setIndexImg(
                        (indexImg + 1) % element.spotlight_photos.length
                      )
                    }
                  />
                )}
              </>
            ) : null}
            {element.wind_force || element.wind_direction ? (
              <DivDadosVento>
                <DadosVento>
                  <svg
                    width="22"
                    height="15"
                    viewBox="0 0 22 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M17.7213 0.0148291L17.1039 0.115669C17.0473 0.125754 17.0473 0.135838 16.9804 0.145922C16.9238 0.156006 16.9135 0.156006 16.8672 0.176174L16.3527 0.382896C16.0285 0.498863 15.7301 0.735838 15.478 0.962728L15.334 1.08374C15.2208 1.20979 15.0921 1.3308 14.9995 1.47197L14.9584 1.52743C14.9327 1.55264 14.9429 1.54256 14.9224 1.57281C14.8761 1.6434 14.8298 1.66357 14.7886 1.72911C14.7629 1.77953 14.768 1.77449 14.7371 1.81483C14.696 1.86021 14.7063 1.84004 14.6805 1.8955L14.4696 2.26861C14.3564 2.47533 14.1403 2.92407 14.2329 3.16105L14.4284 3.53416L14.5931 3.66525C14.7834 3.76609 15.0819 3.80643 15.3082 3.69046C15.4729 3.60979 15.5912 3.49382 15.6735 3.33248C15.7147 3.23668 15.7301 3.15601 15.7713 3.07029L15.8382 2.92911C15.8536 2.89886 15.8433 2.90895 15.8588 2.88374L15.8793 2.85853C16.0131 2.61147 16.2086 2.39466 16.4093 2.19802L16.5636 2.06189C16.5894 2.03668 16.6099 2.02155 16.6408 1.99634L16.9032 1.82996C16.9084 1.82996 16.9084 1.82996 16.9135 1.82491C16.9135 1.82491 16.9186 1.81987 16.9238 1.81987C16.9444 1.80474 16.9341 1.80979 16.9444 1.80474C17.1347 1.69886 17.3302 1.65348 17.5361 1.5829C17.7624 1.50727 18.0917 1.50222 18.3335 1.51735C18.4313 1.52743 18.4982 1.54256 18.6011 1.5476C18.6988 1.55264 18.9921 1.61819 19.0641 1.65853C19.2185 1.74928 19.3986 1.74424 19.697 2.02659C19.8462 2.17281 19.9902 2.33416 20.0777 2.52575C20.0931 2.56609 20.0983 2.58122 20.1189 2.62155C20.1343 2.6518 20.1497 2.6871 20.16 2.71735L20.2938 3.31735C20.3247 3.57449 20.3607 4.14928 20.2578 4.38122C20.2321 4.44676 20.2424 4.41147 20.2269 4.4871L20.1034 4.79466L19.8771 5.15264C19.7947 5.24844 19.6918 5.35937 19.5889 5.435C19.5272 5.48542 19.486 5.54088 19.3523 5.63164C19.2494 5.70222 19.167 5.73248 19.0744 5.7829L19.059 5.79298C18.7709 5.94424 18.6731 5.90895 18.5239 5.95937C18.4622 5.97953 18.4879 5.98458 18.4056 5.98962C18.03 6.00979 17.6081 5.99466 17.2273 5.99466C15.6684 5.9997 14.1043 6.00474 12.5453 6.00979C9.4223 6.02491 6.3044 6.02995 3.18135 6.04004C3.00641 6.04004 1.26739 6.02995 1.1439 6.05012L0.917522 6.11567C0.824911 6.17617 0.747735 6.21651 0.675705 6.29214C0.598529 6.36777 0.552223 6.46861 0.511063 6.56945C0.454467 6.6955 0.454467 6.93248 0.516208 7.06357C0.613964 7.27029 0.7323 7.41147 0.963828 7.49718C1.13876 7.56273 1.27253 7.55264 1.48348 7.5476L5.58409 7.53752C8.70199 7.52743 11.825 7.49718 14.9378 7.50727C15.0973 7.50727 18.1998 7.51735 18.4364 7.49214L18.8275 7.44676C18.8738 7.43668 18.8943 7.42155 18.9458 7.41147C19.095 7.38122 19.2545 7.34088 19.3986 7.28037C19.4346 7.26525 19.4654 7.25516 19.5015 7.24004L19.8102 7.11399C19.8668 7.07869 19.9336 7.04844 19.9954 7.00811L20.2166 6.86693C20.2938 6.81147 20.3555 6.78626 20.4276 6.72575C20.4533 6.70558 20.4739 6.68542 20.5099 6.66021C20.8546 6.40306 21.1633 6.01483 21.3743 5.64676C21.4617 5.49046 21.5595 5.32407 21.6161 5.15769C21.6418 5.08206 21.6624 5.00643 21.6933 4.94592C21.7344 4.86021 21.791 4.57785 21.8064 4.4871C21.827 4.31567 21.863 4.14928 21.863 3.97281C21.8682 3.64508 21.9042 3.14088 21.8219 2.87365C21.7756 2.73248 21.7756 2.56609 21.7087 2.41987L21.6212 2.21819C21.6058 2.17785 21.6109 2.1476 21.5904 2.10727C21.5749 2.06693 21.5595 2.03668 21.544 2.00138C21.5235 1.96105 21.5235 1.93584 21.5029 1.90054C21.5029 1.90054 21.4875 1.87533 21.4772 1.86021C21.1582 1.35601 20.9935 1.08878 20.4996 0.725753C20.2475 0.539199 19.9697 0.352644 19.6712 0.246762C19.522 0.1913 19.3831 0.14088 19.2288 0.110627C18.8583 0.0299552 18.6988 -0.000296911 18.3027 -0.000296911C18.1174 -0.000296911 17.8911 -0.0103809 17.7213 0.0148291Z"
                      fill="#373435"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M2.64632 9.05547C2.564 9.09581 2.34791 9.09581 2.17298 9.32774C2.17298 9.33278 2.16783 9.33782 2.16783 9.33782L2.1524 9.36303C2.07522 9.479 2.05978 9.50925 2.02891 9.64539C1.9929 9.7916 2.02377 9.90253 2.05464 10.0185C2.11124 10.2 2.24501 10.3714 2.41994 10.4622C2.6206 10.563 2.89843 10.5429 3.16597 10.5378C4.26187 10.5378 5.36806 10.5227 6.46395 10.5277C7.56499 10.5378 8.67118 10.5277 9.76708 10.5227L13.8831 10.5076C14.3719 10.5076 14.9224 10.4219 15.2723 10.8C15.3289 10.8605 15.3958 10.916 15.4369 10.9916C15.4678 11.042 15.4935 11.0672 15.5192 11.1227L15.7199 11.7177C15.7302 11.8286 15.7611 12.2067 15.7508 12.2874C15.7405 12.353 15.7251 12.3882 15.7199 12.4588C15.7045 12.6202 15.6016 12.8269 15.5141 12.963C15.4678 13.0437 15.4369 13.079 15.3598 13.1294C15.3443 13.1395 15.3289 13.1546 15.3032 13.1698C15.2569 13.2101 15.2929 13.1849 15.2414 13.2051L14.9687 13.3513C14.7578 13.4269 14.6909 13.4319 14.4799 13.4773C14.2741 13.5227 13.9191 13.4975 13.7082 13.4672C13.6516 13.4572 13.5693 13.4572 13.5178 13.4471L13.2194 13.3412C13.1782 13.3261 13.1165 13.3009 13.0753 13.2807C12.7358 13.1093 12.7358 13.0286 12.5969 12.9378L12.4528 12.8723C12.3293 12.8319 12.2058 12.837 12.0772 12.842C11.8251 12.8521 11.6039 13.0639 11.4907 13.2706C11.4547 13.3412 11.4238 13.5378 11.4289 13.6286C11.4341 13.7698 11.4855 13.9109 11.5524 14.0118L11.5987 14.0723C11.5987 14.0773 11.6039 14.0773 11.6039 14.0773C11.7428 14.2084 12.0309 14.395 12.1955 14.5059C12.2984 14.5714 12.6123 14.7227 12.7461 14.7681L12.9519 14.8488C13.0033 14.8639 13.0239 14.8588 13.1165 14.8941C13.1731 14.9143 13.2348 14.9093 13.2914 14.9294C13.4509 14.995 14.3102 15.0101 14.5571 14.995C14.696 14.9849 14.7887 14.9597 14.9224 14.9445L15.4678 14.7882C15.5964 14.7378 15.6993 14.7126 15.8382 14.637L16.0955 14.4807C16.1727 14.4403 16.2807 14.3798 16.3476 14.3244C16.5225 14.1731 16.7078 13.9765 16.8364 13.7798L17.1657 13.1093C17.1914 13.0235 17.2531 12.8824 17.2531 12.7966C17.2634 12.6605 17.2994 12.5849 17.3046 12.4235C17.3097 12.1614 17.3097 11.879 17.2994 11.6118C17.2994 11.5513 17.2994 11.4807 17.2943 11.4202L17.1657 10.9311C17.1554 10.8958 17.1554 10.8807 17.1502 10.8454C17.1348 10.8 17.1297 10.8252 17.1194 10.7849L17.0525 10.6387C16.965 10.4723 16.8673 10.2958 16.7541 10.1395C16.6666 10.0185 16.5688 9.91261 16.4659 9.81177C16.3579 9.70085 16.2498 9.61513 16.1264 9.52942L15.8794 9.36808C15.6685 9.25715 15.5295 9.20169 15.298 9.12606L15.0562 9.0706C15.0202 9.06051 15.0047 9.05547 14.9636 9.05043C14.8555 9.03026 14.7166 9.00505 14.6086 9.00001C14.4697 9.00001 14.3256 9.00505 14.1867 9.00505L2.85212 9.0353C2.82125 9.0353 2.78524 9.0353 2.75437 9.0353C2.64118 9.04034 2.7235 9.02018 2.64632 9.05547Z"
                      fill="#373435"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M2.75439 3.79657C2.75439 3.95287 2.76983 4.04363 2.84186 4.14951C2.85215 4.16968 2.84701 4.16464 2.8573 4.17976C2.91389 4.29069 3.07853 4.43186 3.20201 4.48732C3.39238 4.57808 3.48499 4.54783 3.70623 4.54783L10.7858 4.52766C11.29 4.52766 11.5576 4.57304 11.856 4.10413C11.9023 4.0285 11.928 3.86716 11.928 3.77136C11.928 3.59993 11.8611 3.43859 11.7531 3.30245C11.6914 3.22682 11.6605 3.20665 11.5833 3.15119L11.4187 3.07052C11.3569 3.06043 11.2849 3.03018 11.2283 3.02514C11.1151 3.01001 4.33907 3.04027 3.54673 3.04027C3.44383 3.04027 3.35122 3.03522 3.27919 3.07052C3.20716 3.10581 3.24832 3.07052 3.166 3.12094C3.16085 3.12094 3.16085 3.12598 3.15571 3.12598C3.15571 3.12598 3.15056 3.13102 3.14542 3.13102C3.11969 3.14615 3.1094 3.14615 3.08368 3.16632C2.93447 3.25203 2.91904 3.31758 2.84186 3.44867C2.77497 3.55959 2.75439 3.67052 2.75439 3.79657Z"
                      fill="#373435"
                    />
                  </svg>
                  <TextoOnda>
                    {element.wind_force}Kn {element.wind_direction}
                  </TextoOnda>
                </DadosVento>
                {/* <TextoPequeno style={{ paddingTop: '0px' }}>{element?.user?.user_location?.city?.name}, {element?.user?.user_location?.state?.uf}</TextoPequeno> */}
              </DivDadosVento>
            ) : null}
            <Corpo>
              <div>
                <TextoPost>{element.description}</TextoPost> <br />
                <TextoPostDestaque>
                  {" "}
                  ({element.total_comments} comentários)
                </TextoPostDestaque>
              </div>
              {element.hash_tags ? (
                <TextoHashTag>{element.hash_tags}</TextoHashTag>
              ) : null}
              {element.total_user_likes === 1 ? (
                <TextoCutida>
                  Curtido por {element?.first_user_like?.name}{" "}
                  {element?.first_user_like?.last_name}
                </TextoCutida>
              ) : element.total_user_likes > 1 ? (
                <TextoCutida>
                  Curtido por {element?.first_user_like?.name}{" "}
                  {element?.first_user_like?.last_name} e mais{" "}
                  {Number(element.total_user_likes) - 1} pessoa(s)
                </TextoCutida>
              ) : (
                <TextoCutida>Nenhuma Curtida</TextoCutida>
              )}
            </Corpo>
          </div>
        );
      })}
    </>
  ) : (
    <Loading>
      <img src="../../loading.gif" alt="" style={{ width: "15%" }} />
    </Loading>
  );
}
